'use client'

import { setExperiment } from '@dafiti/analytics-sdk'
import { useEffect } from 'react'
import { resolveForClient } from '@/helpers/resolveAll'

/**
 * Syncs resolved client-side experiment variants into the analytics-sdk so any
 * registered transport that cares about experiment context (e.g. the Ana
 * transport) can enrich outgoing events without callers having to pass the
 * variant by hand.
 */
export function ExperimentsSync() {
  useEffect(() => {
    resolveForClient().forEach((exp) => {
      if (!exp.variant) return
      setExperiment(exp.key, String(exp.variant))
    })
  }, [])

  return null
}
